import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'jquery/dist/jquery.min.js'
import APP_DATA from './env'

document.title = `${APP_DATA.name[0].toUpperCase() + APP_DATA.name.slice(1).toLowerCase()} · Food Service`

createApp(App).use(router).mount('#app')